import 'scss/solutions/ADring.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'
$(function () {
  $('.banner-apply-aiui-btn').click(function () {
    $('html,body').animate({
      scrollTop: $('#solutions-item-contact').offset().top - 90
    }, 1e3)
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/ADring.js